import { useCallback, useEffect, useState } from "react";
import { PLATFORM_BRAND } from "../../config/platformBrand";

export const DEFAULT_LOGIN_BRAND = Object.freeze({kind:"platform",display_name:PLATFORM_BRAND.name,logo_path:PLATFORM_BRAND.assets.original,version:"platform"});
const backend = process.env.REACT_APP_BACKEND_URL;
export const loginLogoUrl = brand => brand.kind === "agent" ? `${backend}${brand.logo_path}` : PLATFORM_BRAND.assets.original;

export const useLoginBrand = publicId => {
  const [state,setState]=useState({id:publicId,brand:DEFAULT_LOGIN_BRAND});
  const fallback=useCallback(()=>setState({id:publicId,brand:DEFAULT_LOGIN_BRAND}),[publicId]);
  useEffect(()=>{
    let live=true,stream,watchdog;
    const reset=()=>{if(live)fallback();};
    const connect=()=>{
      stream?.close();clearTimeout(watchdog);reset();
      if(!publicId||!document.hasFocus()&&document.visibilityState==="hidden"||navigator.onLine===false)return;
      stream=new EventSource(`${backend}/api/agent-login/public/${encodeURIComponent(publicId)}/events`);
      stream.onmessage=event=>{
        if(!live)return;
        clearTimeout(watchdog);
        try{
          const brand=JSON.parse(event.data);
          const valid=brand.kind==="agent"&&typeof brand.display_name==="string"&&
            /^[a-f0-9]{64}$/.test(brand.version)&&brand.logo_path===`/api/agent-login/public/${publicId}/logo/${brand.version}`;
          setState({id:publicId,brand:valid?brand:DEFAULT_LOGIN_BRAND});
        }catch{reset();}
        watchdog=setTimeout(reset,3500);
      };
      stream.onerror=reset;
    };
    const visibility=()=>{if(document.visibilityState==="hidden"){stream?.close();clearTimeout(watchdog);reset();}else connect();};
    const offline=()=>{stream?.close();clearTimeout(watchdog);reset();};
    connect();document.addEventListener("visibilitychange",visibility);
    window.addEventListener("online",connect);window.addEventListener("offline",offline);window.addEventListener("pagehide",offline);window.addEventListener("pageshow",connect);
    return()=>{live=false;stream?.close();clearTimeout(watchdog);document.removeEventListener("visibilitychange",visibility);window.removeEventListener("online",connect);window.removeEventListener("offline",offline);window.removeEventListener("pagehide",offline);window.removeEventListener("pageshow",connect);};
  },[publicId,fallback]);
  return {brand:state.id===publicId?state.brand:DEFAULT_LOGIN_BRAND,fallback};
};